import React from 'react';
import { Event } from '../../../../stores/events';
import style from './styles.module.scss';
import { Tooltip } from 'antd';

const EventTitle: React.FC<{
    record: Event;
    type: 'title' | 'subtitle';
}> = React.memo(({ record, type }) => {
    const enTranslation = record.translations.find((t) => t.language === 'en');
    const value =
        type === 'title'
            ? enTranslation?.title || ''
            : enTranslation?.subtitle || '';
    const className = type === 'subtitle' ? style.subtitle : style.title;

    return (
        <Tooltip title={value}>
            <div className={className}>{value}</div>
        </Tooltip>
    );
});
EventTitle.displayName = 'EventTitle';

export default EventTitle;
